import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs/Observable';
import { isChinaDomain } from '../../common/common';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { APP_CONFIG } from '../config';
import { LogService } from '../services/logging.service';
import { ApigeeDAO } from './apigee.dao';
import { DefaultRetryHandler } from './handlers/retry.handlers';
import { EnrollmentDataValidator } from './validators/data.validators';

const CLASS_NAME = 'EnrollmentDao';

@Injectable()
export class EnrollmentDao extends ApigeeDAO {

  constructor(
    @Inject(APP_CONFIG) appConfig: IAppConfig,
    http: HttpClient,
    log: LogService,
    cookieService: CookieService
  ) {
    super(
      CLASS_NAME,
      http,
      appConfig,
      appConfig.enrollmentDAO,
      new DefaultRetryHandler(),
      new EnrollmentDataValidator(),
      log,
      cookieService
    );
  }

  public post(enrollmentData: any, simplifiedLoginEnabled: boolean): Observable<any> {
    const url = this.appConfig.enrollmentDAO.url.replace('{version}', simplifiedLoginEnabled ? 'v4' : 'v3');
    return this.doPost(url, enrollmentData, {
      'X-CDC-API-KEY': this.appConfig.enrollmentDAO.cdcApiKey,
      'IHG-SellSource': this.getSellSource()
    });
  }

  private getSellSource(): string {
    let edwSellSourceCountry = 'WEB';

    let edwSellSource = (isChinaDomain(location) ? 'GC' : 'WB');

    if (this.cookieService.check('akamaiIsWirelessDevice') && this.cookieService.get('akamaiIsWirelessDevice') === 'true') {
      edwSellSource = (isChinaDomain(location) ? 'CM' : 'MW');
    }

    if (this.cookieService.check('akamaiIsTablet') && this.cookieService.get('akamaiIsTablet') === 'true') {
      edwSellSource = (isChinaDomain(location) ? 'CT' : 'TB');
    }

    return edwSellSourceCountry + edwSellSource;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/enrollment.dao.ts